import { useCallback, useEffect, useState } from 'react'
import { registerSW } from 'virtual:pwa-register'

const UPDATE_CHECK_INTERVAL = 10 * 60 * 1000 // 10 minutes

export function usePwa() {
  const [offlineReady, setOfflineReady] = useState(false)
  const [mutationsSynced, setMutationsSynced] = useState(false)
  const [mutationQueued, setMutationQueued] = useState(false)

  useEffect(() => {
    // autoUpdate: a new worker activates on its own and the page reloads into
    // it, like every other app. No "new version" banner to tap.
    registerSW({
      immediate: true,
      onOfflineReady() {
        setOfflineReady(true)
      },
      onRegisteredSW(_url, registration) {
        if (!registration) {
          return
        }
        setInterval(() => {
          registration.update()
        }, UPDATE_CHECK_INTERVAL)
      },
    })
  }, [])

  // Listen for service worker messages (queued mutations, sync completion)
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.data?.type === 'MUTATIONS_SYNCED') {
        setMutationQueued(false)
        setMutationsSynced(true)

        function resetSynced() {
          setMutationsSynced(false)
        }

        setTimeout(resetSynced, 5000)
      }
      if (event.data?.type === 'MUTATION_QUEUED') {
        setMutationQueued(true)
      }
    }
    navigator.serviceWorker?.addEventListener('message', handler)
    return () => {
      navigator.serviceWorker?.removeEventListener('message', handler)
    }
  }, [])

  const dismissOfflineReady = useCallback(() => {
    setOfflineReady(false)
  }, [])

  return { offlineReady, mutationQueued, mutationsSynced, dismissOfflineReady }
}
